module.exports = __webpack_public_path__ + "img/登记流程@2x.ea1014b1.png";